import { Injectable } from '@angular/core';

import { BaseProductApi } from '../../BaseProductApi';
import { IDeltacastCatalog } from './../../../../model/product/tena/deltacast/IDeltacastCatalog';

@Injectable()
export class DeltacastCatalogApi extends BaseProductApi<IDeltacastCatalog> {
    protected getBaseUrl() {
        return super.getBaseUrl() + 'hmscatalog/deltacast';
    }
}